import ContentLoader from "react-content-loader";
import styled, { keyframes } from "styled-components";

interface LoaderProps {
  message?: string;
  length?: number;
  spinnerIcon?: React.ReactNode;
}

const TableCustomLoader = (props: LoaderProps) => {
  const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || '{}');
  const layoutTheme = agencyInfo.data?.layout_theme || 'light';
   const {
    message = "",
    spinnerIcon = "✨"
  } = props;

  const showMessage = message !== "";

  return (
    <>
      <div className="table-container" style={{
        display: 'grid',
        alignItems: 'center',
        gap: '1rem',
        width: '100%'
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {Array.from({ length: props.length ? props.length : 10 }).map((_, index) => (
              <tr key={index}>
                <td style={cellStyle}><Loader layout={layoutTheme} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {showMessage && <>
          <LoadingContainer>
            <Spinner>{spinnerIcon}</Spinner>
            <LoadingText>
              {message}
              <Dots />
            </LoadingText>
          </LoadingContainer>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {Array.from({ length: props.length ? props.length : 10 }).map((_, index) => (
              <tr key={index}>
                <td style={cellStyle}><Loader layout={layoutTheme} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        </>}
      </div>
    </>
  );
};

/* ──────────────── Animations ──────────────── */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const dotPulse = keyframes`
  0% { content: ''; }
  15% { content: '.'; }
  30% { content: '..'; }
  45% { content: '...'; }
  60% { content: '..'; }
  75% { content: '.'; }
  90%, 100% { content: ''; }
`;

/* ──────────────── Styled Components ──────────────── */

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  margin: 8px 0;
`;

const Spinner = styled.span`
  display: inline-block;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  position: relative;
`;

const Dots = styled.span`
  &::after {
    content: "";
    animation: ${dotPulse} 1.5s infinite;
  }
`;


const Loader = ({ layout }: { layout: string }) => (
  <ContentLoader width="100%" height={15}
    speed={2}
    backgroundColor={layout === 'light' ? '#f3f3f3' : 'var(--bs-header-bg)'}
    foregroundColor={layout === 'light' ? '#ecebeb' : 'var(--bs-white)'}>
    <rect x="0" y="0" rx="4" ry="4" width="100%" height="15" />
  </ContentLoader>
);

const cellStyle = {
  padding: "10px",
};

export default TableCustomLoader;